<script setup lang="ts">
const props = withDefaults(defineProps<{
  items: number
  delay?: number
}>(), {
  delay: 3000,
})

const currentIndex = ref(0)
const intervalId = ref<NodeJS.Timeout | null>(null)

function getClasses(index: number) {
  const isActive = currentIndex.value === index
  const isPrevious = (index + 1) % props.items === currentIndex.value

  return [
    isActive ? 'translate-x-0' : isPrevious ? '-translate-x-full' : 'translate-x-full',
    isActive
      ? 'animate-[carousel-slide-bounce_.4s_ease-out]'
      : isPrevious
        ? 'animate-[carousel-slide-swipe_.3s_ease-out]'
        : '',
  ].filter(Boolean).join(' ')
}

onMounted(() => {
  intervalId.value = setInterval(() => {
    currentIndex.value = (currentIndex.value + 1) % props.items
  }, props.delay)
})

onUnmounted(() => {
  if (intervalId.value)
    clearInterval(intervalId.value)
})
</script>

<template>
  <div class="relative of-hidden">
    <div
      v-for="(item, index) in items" :key="index"
      :data-testid="`slide-${index}${currentIndex === index ? '-active' : ''}`"
      :class="getClasses(index)"
      class="absolute inset-0 flex keyframes-carousel-slide-bounce keyframes-carousel-slide-swipe items-center justify-center"
    >
      <slot :item="item" :index="index" :name="`slide-${index}`" />
    </div>
  </div>
</template>
